import {Component, OnInit} from '@angular/core';
import FileSaver from 'file-saver';

import {VoucherGenService} from './services/voucher-gen.service';

@Component({
  selector: 'voucher-gen',
  templateUrl: './voucher-gen.component.html',
  styleUrls: ['./voucher-gen.component.css'],
})

export class VoucherGenComponent {

  public amount: number;
  public codeToValidate: string;
  public isCodeValid: boolean;
  public codeToInvalidate: string;
  public isCodeNowInvalid: boolean;

  constructor(private voucherGenService: VoucherGenService) { }

  public createVouchers(): void {
    this.voucherGenService.createVoucher(this.amount)
      .subscribe((vouchers: Blob) => {
        FileSaver.saveAs(vouchers, 'VoucherCodes.csv');
      });
  }

  public validateCode(): void {
    this.voucherGenService.validateCode(this.codeToValidate)
      .subscribe((isValid: boolean) => {
        this.isCodeValid = isValid;
      });
  }

  public invalidateCode(): void {
    this.voucherGenService.invalidateCode(this.codeToInvalidate)
      .subscribe((message: string) => {
        this.isCodeNowInvalid = true;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-gen/voucher-gen.component.ts